import styled from '@emotion/styled';
import { PROFILE_STAGE } from 'domain/entities/CompanyUser/CompanyUser';
import { ActionButton } from 'ui/components/elements/ActionButton/ActionButton';
import Img01 from 'ui/images/top/topService_img01@2x.png';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { companyUserContext } from 'application/contexts/useCompanyUser';

const Wrapper = styled.div`
    width: 80svw;
    padding: 30px 20px;
    max-width: 600px;
    border-radius: 20px;
    background: var(--white);
    margin: 10px auto;
    text-align: center;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

    img {
        width: 170px;
        margin: 0 auto;
    }
`;

const Title = styled.div`
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    line-height: 1.5;
`;

/**
 * プロフィール登録が必要なユーザーに表示するモーダル
 */
export const NeedProfileRegistration: React.FC = () => {
    const { user } = useContext(companyUserContext);
    const navigate = useNavigate();
    if (!user) return null;

    return (
        <Wrapper>
            <Title>【サービスを利用するためにプロフィールを登録してください】</Title>
            {user?.account_profile_stage === PROFILE_STAGE.NEED_COMPANY_INFO && (
                <>
                    <Title>
                        企業プロフィールを充実させ
                        <br />
                        仲介業者からのオファー率をアップしましょう！
                    </Title>
                    <img src={Img01} alt="マッチング" />
                    <ActionButton
                        onClick={() => navigate('/company/profile/application/')}
                        bgColor="main-color-blue"
                        style={{
                            width: '450px',
                            margin: '10px auto',
                        }}
                    >
                        詳細情報を入力する
                    </ActionButton>
                </>
            )}
            {user?.account_profile_stage === PROFILE_STAGE.NEED_USER_PROFILE && (
                <>
                    <Title>
                        ユーザー情報の登録が完了していません
                        <br />
                        マッチング後のやりとりにはプロフィール登録が必要です
                    </Title>
                    <img src={Img01} alt="マッチング" />
                    <ActionButton
                        onClick={() => navigate('/company/registration/user_profile/')}
                        bgColor="main-color-blue"
                        style={{
                            width: '450px',
                            margin: '10px auto',
                        }}
                    >
                        詳細情報を入力する
                    </ActionButton>
                </>
            )}
        </Wrapper>
    );
};
